import React, { FC } from 'react';
import { CalculatorsFragment } from '../../types/graphqlTypes';
import { Columns, Grid } from '../Grid';
import { Section } from '../Section';
import { MortgageEstimator } from './MortgageEstimator';
import { StampDutyCalculator } from './StampDutyCalculator';
import { LeaseExtensionCalculator } from './LeaseExtensionCalculator';
import { StampDutyCalculatorWithBreakdown } from './StampDutyCalculatorWithBreakdown';

const MortgageEstimatorWithBoarder: FC = () => <MortgageEstimator border />;
const StampDutyCalculatorWithBoarder: FC = () => <StampDutyCalculator border />;
const LeaseExtensionCalculatorWithBoarder: FC = () => (
  <LeaseExtensionCalculator border heading="Lease extension calculator" />
);

export const Calculators: FC<Omit<CalculatorsFragment, '__typename'>> = ({
  stampDutyCalculator,
  mortgageEstimatorCalculator,
  leaseExtensionCalculator,
  backgroundColour,
  ...rest
}) => {
  const components: any[] = [];

  if (stampDutyCalculator && (mortgageEstimatorCalculator || leaseExtensionCalculator)) {
    components.push(StampDutyCalculatorWithBoarder);
  }
  if (stampDutyCalculator && !mortgageEstimatorCalculator && !leaseExtensionCalculator) {
    components.push(StampDutyCalculatorWithBreakdown);
  }

  if (mortgageEstimatorCalculator) {
    components.push(MortgageEstimatorWithBoarder);
  }

  if (leaseExtensionCalculator) {
    components.push(LeaseExtensionCalculatorWithBoarder);
  }

  if (components.length === 1) {
    const Component = components[0];
    return (
      <Section contained narrow {...rest} background={backgroundColour}>
        <Component />
      </Section>
    );
  }
  return (
    <Section contained narrow={components.length < 3} background={backgroundColour} {...rest}>
      <Grid desktopColumns={components.length.toString() as Columns}>
        {components.map((Component, index) => (
          <Component key={index} />
        ))}
      </Grid>
    </Section>
  );
};
